import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { GraphQLModule } from '../graphql/graphql.module'
import { AuthEffects } from './auth.effects'
import * as fromAuth from './auth.reducer'
import { AuthService } from './auth.service'

@NgModule({
  providers: [AuthService],
  imports: [
    GraphQLModule,
    CommonModule,
    StoreModule.forFeature(fromAuth.authFeatureKey, fromAuth.reducer),
    EffectsModule.forFeature([AuthEffects]),
  ],
})
export class AuthModule {}
